import { inject } from "mobx-react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { HotelHeartButton } from "../HotelHeartButton/HotelHeartButton";
import * as React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { AnalyticsStore } from "bernie-plugin-mobx";
import { HotelBadge } from "./HotelBadge/HotelBadge";
import { getOptimizedImageUrl } from "src/components/flexComponents/Hotels/utils/hotelOptimizedImage";

interface CardMediaOverallInfoProps {
  index: number;
  hotel: Hotel;
  analytics?: AnalyticsStore;
  context: ExtendedContextStore;
  moduleName?: string;
  displayBadges?: boolean;
}

/**
 * Represents a {@see HotelCard}'s media (image, carousel, favorite button, etc.)
 */

export const CardMediaOverallInfo: React.FC<CardMediaOverallInfoProps> = inject("analytics")(
  ({ hotel, context, moduleName = "hotels", displayBadges, ...props }) => {
    const { hotelName } = hotel;
    const hotelImageUrl = getOptimizedImageUrl(hotel, context);

    return (
      <UitkFigure ratio={UitkFigureAspectRatioType.R21_9} {...props}>
        <div>
          <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage lazyLoading="lazy" />
        </div>
        <Experiment name="trips_toggle_BEXG_trip_planning_release_1">
          <ExperimentControl>
            <HotelHeartButton moduleName={moduleName} hotel={hotel} />
          </ExperimentControl>
          <ExperimentVariant bucket={1} />
        </Experiment>
        {displayBadges && <HotelBadge travelerReviewContent={hotel.travelerReviewContent} />}
      </UitkFigure>
    );
  }
);
